import { render, staticRenderFns } from "./authGoodsStatus.vue?vue&type=template&id=077ccd7c&scope=scope"
import script from "./authGoodsStatus.vue?vue&type=script&lang=js"
export * from "./authGoodsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports